import React from 'react';
import { Modal } from '../../../CommonComponents/OPL/Modal/Modal';
import { ModalHeader } from '../../../CommonComponents/OPL/Modal/ModalHeader';
import { ModalCloseButton } from '../../../CommonComponents/OPL/Modal/ModalCloseButton';
import { ModalBody } from '../../../CommonComponents/OPL/Modal/ModalBody';
import { ModalFooter } from '../../../CommonComponents/OPL/Modal/ModalFooter';
import { Button } from '../../../CommonComponents/OPL/Button/Button';
import { VisualPicker } from '../../../CommonComponents/OPL/VisualPicker/VisualPicker';
import { Text } from '../../../CommonComponents/OPL/Text/Text';
import {
  PLANS_MAX_COUNT,
  PLANS_MIN_COUNT,
} from '../../../FinancialPlanOPL/Goals/goals/Retirement/pages/RetirementSideBySide/RetirementSideBySide.meta';
import { ComparePlansProps, useComparePlans } from './useComparePlans';

const HEADER_ID = 'pdf--edit-compare-plans-modal--header';
const FORM_ID = 'pdf--edit-compare-plans-modal--form';

export const ComparePlans = (props: ComparePlansProps) => {
  const {
    data: { plans },
    onClose,
  } = props;

  const { fields, setValue, selectedPlansCount, onSubmit } = useComparePlans(props);

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      aria={{ labelledby: HEADER_ID }}
      shouldCloseOnOverlayClick={false}
    >
      <ModalHeader as="h2" id={HEADER_ID}>
        Edit Compare Plans
      </ModalHeader>
      <ModalCloseButton onClick={onClose} />

      <ModalBody id={FORM_ID} as="form" onSubmit={onSubmit}>
        <Text as="p" color="neutral.500">
          Select the plan(s) you would like to show in the PDF
        </Text>

        {fields.map((field, index) => {
          return (
            <VisualPicker
              key={field.key}
              variant="checkbox"
              label={plans[index].name}
              checked={field.selected}
              onChange={evt => setValue(`planFields.${index}.selected`, evt.target.checked)}
              disabled={!field.selected && selectedPlansCount === PLANS_MAX_COUNT}
              mt="8"
            />
          );
        })}
      </ModalBody>

      <ModalFooter>
        <Button variant="subtleInactive" onClick={onClose}>
          Cancel
        </Button>

        <Button type="submit" form={FORM_ID} disabled={selectedPlansCount < PLANS_MIN_COUNT} ml="8">
          Save Changes
        </Button>
      </ModalFooter>
    </Modal>
  );
};
